export class GlobalParametersDto {
  constructor(
    public notaryMessage: string,
    public chiefOfficer: string,
    public displayAlert: boolean,
    public alertMessage: string,
    public agentMessage: string,
  ) {}
}
